<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelCreateSignalsSet[actualLanguage] }}</h3>
          
            <div class="form-group">
                <div class="col-xs-12 col-md-12">
                    <label for="register4-firstname">{{ textBoxLabelTemplateId[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="templateId" placeholder="Identifant de gabarit / Template ID">
                </div>

            </div>


            <!-- ================================================================= -->
            <!-- Section ajout de variables-->
            <!-- ================================================================= -->
            <div class="block block-bordered block-themed">
              <div class="form-group">

                
                <div class="col-sm-12">
                  <div class="block-header bg-primary-dark">     
                    <h4 class="font-w300 push-10 text-white-op">{{ textSectionTitleVariables[actualLanguage] }}</h4>
                  </div>
                </div>
                
              
                <div class="block-content">
                  <div class="form-group">                    
                      <div v-for="(signal,index) in deviceSignals" class="col-xs-12 col-md-12">

                        <div class="block block-bordered block-themed block-content">
                          <div class="form-group">

                            <div class="col-sm-12 col-md-6 col-lg-4">
                              <label for="register4-firstname">{{ labelVariableVarName[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="signal.signalName" placeholder="Variable">
                            </div> 

                            <div class="col-sm-12 col-md-6 col-lg-4">
                              <label for="register4-firstname">{{ labelVariableLabelFR[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="signal.signalLabel.FR" placeholder="Nom/Name">
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-4">
                              <label for="register4-firstname">{{ labelVariableLabelEN[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="signal.signalLabel.EN" placeholder="Nom/Name">
                            </div>

                   

                            <div class="col-sm-12 col-md-6 col-lg-6">
                              <label  for="example-multiple-select">{{ labelVariableDataFormat[actualLanguage] }}</label>
                              <select class="form-control" v-model=signal.dataFormat size="1">
                                  <option value="Single">Simple / Single</option>
                                  <option value="Array">Vecteur (liste) / Array</option>
                              </select>
                            </div> 

                            <div class="col-sm-12 col-md-6 col-lg-6">
                              <label  for="example-multiple-select">{{ labelVariableDataType[actualLanguage] }}</label>
                              <select class="form-control" v-model=signal.dataType size="1">
                                  <option value="Numeric">Numerique / Numeric</option>
                                  <option value="Bool">Booléen / Boolean</option>
                              </select>
                            </div> 

                            
                          </div>
                        </div>

                      </div>
                  </div>

                  <div class="form-group">
                    <div class="col-sm-12 col-md-6">
                        <p><button @click="addDeviceSignal()" type="button" class="btn btn-sm btn-success" name="button">
                          <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddSignal[actualLanguage] }}</span></button></p>
                    </div>   

                    <div v-if="deviceSignals.length > 0" class="col-sm-12 col-md-6">
                        <p><button @click="deleteDeviceSignal()" type="button" class="btn btn-sm btn-danger" name="button">
                          <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteSignal[actualLanguage] }}</span></button></p>
                    </div> 
                  </div> 


                </div>
              </div>
            </div>


            <!-- ================================================================= -->
            <!-- Section ajout de parametres de controle de l'appareil-->
            <!-- ================================================================= -->
            <div class="block block-bordered block-themed">
              <div class="form-group">

                
                <div class="col-sm-12">
                  <div class="block-header bg-primary-dark">     
                    <h4 class="font-w300 push-10 text-white-op">{{ textSectionTitleControlParameter[actualLanguage] }}</h4>
                  </div>
                </div>
                



                <div class="block-content">
                  <div class="form-group"> 
                    <div class="col-sm-12">
                      <h5 class="font-w300 push-10">{{ textParameterDescription01[actualLanguage] }}</h5>
                      <h5 class="font-w300 push-10">{{ textParameterDescription02[actualLanguage] }}</h5>
                    </div>

                                   
                      <div v-for="(parameter,index3) in controlParameters" class="col-xs-12 col-md-12">

                        <div class="block block-bordered block-themed block-content">
                          <div class="form-group">

                            <div class="col-sm-12 col-md-6 col-lg-4">
                              <label for="register4-firstname">{{ labelParameterLabelFR[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="parameter.parameterLabel.FR" placeholder="Nom/Name">
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-4">
                              <label for="register4-firstname">{{ labelParameterLabelEN[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="parameter.parameterLabel.EN" placeholder="Nom/Name">
                            </div>

                            <div class="col-sm-12 col-md-6 col-lg-4">
                              <label for="register4-firstname">{{ labelParameterVarName[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="parameter.parameterName" placeholder="Variable">
                            </div>                    


                            <div class="col-sm-12 col-md-6 col-lg-3">
                              <label  for="example-multiple-select">{{ labelParameterDataType[actualLanguage] }}</label>
                              <select @change="changeDataType(index3)" class="form-control" v-model=parameter.dataType size="1">
                                  <option value="Numeric">Numerique / Numeric</option>
                                  <option value="String">Chaîne caractère / String</option>
                                  <option value="Bool">Booléen / Boolean</option>
                              </select>
                            </div> 

                            <!-- ================================================================= 
                            <div v-if="parameter.dataType==='Bool'" class="col-sm-12 col-md-6 col-lg-3">
                              <div class="col-xs-12">
                              <label for="register4-firstname">{{ labelParameterValue[actualLanguage] }} : On/Off</label>
                              </div>
                              <div class="col-xs-3">
                                <label class="css-input switch switch-success">
                                    <input type="checkbox" checked v-model="parameter.dataValue"><span></span>
                                </label>
                                </div>
                            </div>

                            <div v-else class="col-sm-12 col-md-6 col-lg-3">
                              <label for="register4-firstname">{{ labelParameterValue[actualLanguage] }}</label>
                              <input class="form-control" type="text" v-model="parameter.dataValue" placeholder="Value">
                            </div> 
                            -->


                            <div class="col-xs-12 col-md-3">
                              <div class="col-xs-12">
                                <label for="register4-firstname">{{labelParameterFlagVisibleByCustomer[actualLanguage]}}</label>
                              </div>
                              <div class="col-xs-3">
                                <label class="css-input switch switch-success">
                                    <input type="checkbox" checked v-model="parameter.flagViewByCustomer"><span></span>
                                </label>
                              </div>
                            </div>

                            <div class="col-xs-12 col-md-3">
                              <div class="col-xs-12">
                                <label for="register4-firstname">{{labelParameterFlagEditByCustomer[actualLanguage]}}</label>
                              </div>
                              <div class="col-xs-3">
                                <label class="css-input switch switch-success">
                                    <input type="checkbox" checked v-model="parameter.flagEditByCustomer"><span></span>
                                </label>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                  </div>

                  <div class="form-group">
                    <div class="col-sm-12 col-md-6">
                        <p><button @click="addDeviceControlParameter()" type="button" class="btn btn-sm btn-success" name="button">
                          <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddParameter[actualLanguage] }}</span></button></p>
                    </div>   

                    <div v-if="controlParameters.length > 0" class="col-sm-12 col-md-6">
                        <p><button @click="deleteDeviceControlParameter()" type="button" class="btn btn-sm btn-danger" name="button">
                          <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteParameter[actualLanguage] }}</span></button></p>
                    </div> 
                  </div> 


                </div>
              </div>
            </div>

 







            <div class="form-group">
              <div v-if="deviceSignals.length > 0" class="col-sm-12 col-md-12">

                <div class="col-sm-12 col-md-12 col-lg-12 push">
                  <label for="register4-firstname">{{ labelSelectApiKey[actualLanguage] }} </label>
                  <select class="form-control" v-model=selectedApiKey size="1">
                      <option v-for="key in overlayParameters.organizationApiKeys" v-bind:value="key.key">{{key.referenceName}} : {{key.key}}</option>
                  </select>

                </div>


                <div v-if="selectedApiKey.length > 0">
                    <p><button @click="saveSignalSetTemplate()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="templateIsCreating"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>



          </form>
        </div>

  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'AddDeviceTemplateForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage : "FR",

      sectionLabelCreateSignalsSet:{FR: "Éditeur d'ensemble de signaux et paramètres de contrôle", EN: 'Signal and control parameters set editor'},

      textBoxLabelTemplateId:{FR: "Identifiant de l'ensemble", EN: 'Set ID'},
      templateId : "",

      textSectionTitleVariables:{FR: "Liste des signaux", EN: "Signals list"},

      deviceSignals : [],
      labelVariableLabelFR:{FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)"},
      labelVariableLabelEN:{FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)"},
      labelVariableVarName:{FR: "Signal (nom de variable)", EN: "Signal (variable name)"},

      labelVariableDataFormat:{FR: "Format de donnée", EN: "Data format"},
      labelVariableDataType:{FR: "Type de donnée", EN: "Data type"},

      buttonAddSignal:{FR: "Ajouter un signal", EN: 'Add signal'},
      buttonDeleteSignal:{FR: "Supprimer dernière signal", EN: 'Deleta last signal'},



      controlParameters : [],
      textSectionTitleControlParameter:{FR: "Parametre de control de l'appareil de mesure",
                                        EN: "Control parameters of the measurement device"},
      textParameterDescription01:{FR: "Les paramètres de contrôle permettent de modifier un état de l'appareil en cours de fonctionnement.",
                                        EN: "The control parameters make it possible to modify a state ot the device during operation"},
      textParameterDescription02:{FR: "Une nouvelle valeur est modifiable via la page de configuration de l'appareil et transmise à l'appareil lors que ce dernier communique des mesures au cloud EV Sens.",
                                        EN: "A new value can be modified via the device configuration page and transmitted to the device when the latter communicates measurements to the EV Sens cloud"},

      labelParameterLabelFR:{FR: "Étiquette affichée (FR)", EN: "Displayed label (FR)"},
      labelParameterLabelEN:{FR: "Étiquette affichée (EN)", EN: "Displayed label (EN)"},
      labelParameterVarName:{FR: "Nom variable programme", EN: "Program variable name"},
      labelParameterDataType:{FR: "Type de donnée", EN: "Data type"},
      labelParameterValue:{FR: "Valeur", EN: "Value"},
      labelParameterFlagVisibleByCustomer:{FR: "Visible par client", EN: "Visible by customer"}, 
      labelParameterFlagEditByCustomer:{FR: "Modifiable par client", EN: "Editable by customer"}, 
      labelParameter:{FR: "", EN: ""}, 
  
      buttonAddParameter:{FR: "Ajouter un parametre", EN: 'Add parameter'},
      buttonDeleteParameter:{FR: "Supprimer dernière parametre", EN: 'Deleta last parameter'},


      labelChannelToCreate :{FR: "Affichage d'appareils créés lors de l'enregistrement au profil client", EN: 'Displayed device created when customer bind the measurement device'},
      labelChannelToCreate2 :{FR: "Sélection multiple possible (maintenir la touche CTRL pour sélection multiple)", EN: 'Multiple selection is possible (maintain CTRL key for multiple selection)'},
      channelTemplateList : [],
      channelsToCreate : [],

      selectedApiKey : "",

      buttonLabelSave:{FR: "Créer/Modifier le gabarit", EN: 'Create/Modify the template'},

      labelSelectApiKey:{FR: "Cette action requiert une clef d'API maître, vous devez en sélectionné une:", EN: 'This action require a master API key, select one:'},
      messageProfileRefreshAction:{FR: "Le gabarit a été créé dans le système, cette opération requiert un rafraichissement des données de votre organisation (fait automatiquement).",
                                   EN: 'The template was created in the system, this action require an organization data refresh (done automatically).'},

    }
  },


  methods: {

    addDeviceSignal(){
      this.deviceSignals.push({
        signalLabel:{FR:"",EN:""},
        signalName:"",
        dataFormat :"",
        dataType:""
      })
    },
    deleteDeviceSignal(){
      this.deviceSignals.pop()
    },


    addDeviceControlParameter(){
      this.controlParameters.push({
        parameterLabel:{FR:"",EN:""},
        parameterName:"",
        dataType:"",
        dataValue:"",
        dataValueLastTransmit:"999999999999",
        flagViewByCustomer:false,
        flagEditByCustomer:false,
      })
    },
    deleteDeviceControlParameter(){
      this.controlParameters.pop()
    },

    changeDataType(index){
      if(this.controlParameters[index].dataType=='Numeric'){this.controlParameters[index].dataValue='0'}
      if(this.controlParameters[index].dataType=='Bool'){this.controlParameters[index].dataValue=false}
    },

    saveSignalSetTemplate() {
      var ValidationFlag = true
      if(this.templateId.length==0){
        var ErrorMessage = {FR:"L'identifiant de gabarit est vide!",EN:"The template ID is empty!"}
        window.alert(ErrorMessage[this.actualLanguage])
        ValidationFlag = false
      }

      if (ValidationFlag){
          var postBody = {
            'postAction':'createSignalSetTemplate',
            'postSubAction':this.overlayParameters.action,
            'organization_id':this.overlayParameters.organizationId.substring(5,20),
            'template_id':this.templateId,
            'deviceSignals':this.deviceSignals,
            'controlParameters':this.controlParameters,
          }

          var requestData = { 'postAction':'ApiCustomerGateway',
                              'organizationId': this.overlayParameters.organizationId,
                              'organizationApiKey': this.selectedApiKey,
                              'postBody':postBody ,
                            }

          this.templateIsCreating = true
          this.$store.dispatch('sessionStore/postOrganization', requestData)
              .then((response) => {
                //console.log('--------------------------')
                //console.log(response.data)
                this.templateIsCreating  = false
              if(response.data.Code=='OK'){
                  window.alert(this.messageProfileRefreshAction[this.actualLanguage])
                  this.$store.dispatch('sessionStore/refreshProfileData')
                  this.$store.dispatch('overlayStore/toggleModal',false)
                  }
                  else{ window.alert(response.data.CallResponse.message)}
              })
      }      
      
      },


    getSignalSetTemplate(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationSingleSignalsSet',
                            'organizationId': this.overlayParameters.organizationId,
                            'templateId': this.overlayParameters.templateId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get Channel Template-----')
              //console.log(response.data)
              
            if(response.data.Code=='OK'){
                this.templateId = this.overlayParameters.templateId
                this.deviceSignals = response.data.SignalsSet.deviceSignals
                this.controlParameters=response.data.SignalsSet.controlParameters
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  

    },

  
  },

  computed: {
    ...mapState('sessionStore', ['profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //console.log('-----Profile Data----')
    //console.log(this.profileData)

    if (this.overlayParameters.action == 'edit'){
        this.getSignalSetTemplate()
    }

  }


}
</script>



// WEBPACK FOOTER //
// OrganizationApiSignalsSetAddForm.vue?7c138f3e